import { Link } from "@tanstack/react-router";
import { Play } from "lucide-react";

export function VideoTutorialThumbnail() {
  return (
    <div className="relative overflow-hidden">
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-y-2 overflow-hidden rounded-r-xl bg-black transition-all duration-500 ease-in-out">
        <Link
          to="/intro-video"
          className="peer before:bg-theme-primary focus-visible:outline-theme-primary relative z-1 rounded-full border border-white/30 p-6 text-white transition duration-500 ease-in-out before:absolute before:-inset-1.5 before:rounded-full before:opacity-0 before:transition-all before:duration-500 before:ease-in-out before:content-[''] hover:border-transparent hover:before:inset-0 hover:before:opacity-100 focus-visible:border-transparent focus-visible:outline-hidden focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-2 focus-visible:before:inset-0 focus-visible:before:opacity-100"
        >
          <Play className="relative size-6" fill="#fff" />
        </Link>
        <img
          src="/video.jpeg"
          alt=""
          className="absolute inset-0 object-cover opacity-20 grayscale transition-all duration-500 ease-in-out peer-hover:scale-105 peer-hover:opacity-25 peer-hover:grayscale-0 peer-focus-visible:scale-105 peer-focus-visible:opacity-25 peer-focus-visible:grayscale-0"
        />
        <span className="z-1 text-sm text-white">Sådan gør du</span>
      </div>
    </div>
  );
}
